import React from 'react';
import { Box, Grid, Skeleton, Stack } from '@mui/material';

const MarketSkeleton = () => {
  return (
    <Box>
      {/* HERO IMAGE */}
      <Box sx={{ position: 'relative' }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={850}
          animation="wave"
        />

        {/* Offer timer card (left) */}
        <Box
          sx={{
            position: 'absolute',
            top: 90,
            left: 106,
            width: 300,
            bgcolor: '#fff',
            borderRadius: '6px',
            p: 2,
          }}
        >
          <Skeleton width="50%" height={20} />
          <Stack direction="row" spacing={1} mt={2}>
            {[1, 2, 3, 4].map((i) => (
              <Skeleton key={i} variant="rectangular" width={55} height={48} />
            ))}
          </Stack>
        </Box>

        {/* Agent card */}
        <Box
          sx={{
            position: 'absolute',
            top: 90,
            right: 145,
            width: 260,
            bgcolor: '#fff',
            borderRadius: '6px',
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
          }}
        >
          <Skeleton variant="circular" width={44} height={44} />

          <Box flex={1}>
            <Skeleton width="80%" height={16} />
            <Skeleton width="60%" height={14} />
          </Box>

          <Skeleton variant="circular" width={28} height={28} />
          <Skeleton variant="circular" width={28} height={28} />
        </Box>

        {/* RayWhite tag — moved below agent card correctly */}
        <Box
          sx={{
            position: 'absolute',
            top: 170,
            right: 145,
          }}
        >
          <Skeleton
            variant="rectangular"
            width={120}
            height={50}
            sx={{ borderRadius: '4px' }}
          />
        </Box>

        {/* Property title overlay */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 50,
            left: 106,
          }}
        >
          <Skeleton width={80} height={24} />

          <Skeleton width={320} height={40} />

          <Skeleton width={700} height={40} />
        </Box>
      </Box>

      {/* BELOW IMAGE CONTENT */}
      <Grid
        container
        spacing={3}
        sx={{
          px: '106px',
          py: 4,
        }}
      >
        {/* LEFT MAIN CONTENT */}
        <Grid item xs={8}>
          {/* Back + Market Sentiment + Follow buttons in same row */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <Skeleton width={180} height={24} />

              <Skeleton width={160} height={32} />
            </Stack>

            {/* Follow / Share / Invite / Insights aligned right */}
            <Stack direction="row" spacing={2}>
              <Skeleton variant="rectangular" width={90} height={36} />
              <Skeleton variant="rectangular" width={90} height={36} />
              <Skeleton variant="rectangular" width={90} height={36} />
              <Skeleton variant="rectangular" width={90} height={36} />
            </Stack>
          </Stack>

          {/* Views */}
          <Skeleton width={160} height={18} sx={{ mt: 2 }} />

          {/* Trade assist title */}
          <Skeleton width={260} height={34} sx={{ mt: 3 }} />

          {/* Action buttons */}
          <Stack direction="row" spacing={2} mt={2}>
            <Skeleton variant="rectangular" width={240} height={60} />
            <Skeleton variant="rectangular" width={240} height={60} />
          </Stack>

          {/* Auction */}
          <Skeleton width="55%" height={26} sx={{ mt: 4 }} />

          {/* Inspection */}
          <Skeleton width="65%" height={26} />

          {/* Description */}
          <Skeleton width="30%" height={26} sx={{ mt: 4 }} />

          <Skeleton width="100%" height={18} />

          <Skeleton width="100%" height={18} />

          <Skeleton width="85%" height={18} />
        </Grid>

        {/* RIGHT SIDE PANEL */}
        <Grid item xs={4}>
          {/* Property ID */}
          <Skeleton width="65%" height={22} />

          {/* Highest Offer Card */}
          <Box
            sx={{
              mt: 2,
              p: 2,
              borderRadius: '8px',
              border: '1px solid #eee',
            }}
          >
            <Skeleton width="70%" height={22} />

            <Skeleton width="50%" height={36} sx={{ mt: 1 }} />

            <Skeleton width="60%" height={16} />
          </Box>

          {/* Secondary card */}
          <Skeleton
            variant="rectangular"
            width="100%"
            height={200}
            sx={{
              mt: 3,
              borderRadius: '8px',
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MarketSkeleton;
